<!--
 @author wangjp
 @description 产品二级品类管理
 @date 2024年9月12日16:51:06
 -->
<template>
  <el-container>
    <el-dialog title="编辑" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
               @open="handleOpen" :close-on-click-modal="false">
      <div style="height: calc(100% - 90px);">
        <el-row style="padding: 30px">
          <el-form ref="form" :model="form" :rules="rules" label-width="130px">
            <el-form-item label="所属一级品类" prop="pid">
              <el-select v-model="form.pid" placeholder="请选择所属一级品类" style="width: 100%" size="medium">
                <el-option v-for="item in categorys" :key="item.id" :label="item.name"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="品类名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入品类名称" size="medium" />
            </el-form-item>
          </el-form>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
        <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import {commonFormMixin} from '@/utils/commonFormMixin'
import {commonAttachMixin} from "@/utils/commonAttachMixin";
export default {
  name: "InfoProductCategoryForm",
  mixins: [commonFormMixin,commonAttachMixin],
  props: ['formVisible', 'selRow', 'submitUrl'],
  data() {
    return {
      categorys: [],
      rules: {
      }
    }
  },
  mounted() {
    this.postRequest('/core/infoProductCategory/findAll').then(res => {
      if(res.status == 200){
        this.categorys = res.obj;
      }

    });
  },
  methods: {
  }
}
</script>